import React from 'react'
import { ParticipantsVoiceItemContent } from './Content'
import { ParticipantsVoiceItemImage } from './Image'
import { ParticipantsVoiceItemParticipantInfo } from './ParticipantInformation'

type Props = {
  content: string
  participantInfo: string
}

export const ParticipantsVoiceSpLayout = ({
  content,
  participantInfo,
}: Props): JSX.Element => (
  <div>
    <div className="flex flex-row justify-between">
      <div>
        <ParticipantsVoiceItemImage />
      </div>
      <div className="flex items-end">
        <ParticipantsVoiceItemParticipantInfo {...{ participantInfo }} />
      </div>
    </div>

    <div className="mt-[8.1vw]">
      <ParticipantsVoiceItemContent {...{ content }} />
    </div>
  </div>
)
